// @flow
import React from 'react';
import cx from 'classnames';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

import * as styles from './Header.module.scss';
import Logo from '../../images/logo-color.svg';
import { merchantMenu } from './const';

const HeaderMerchant = ({
  siteTitle,
  headerAlpha,
  pathname,
}: {
  siteTitle: string,
  headerAlpha: number,
  pathname: string,
}) => {
  return (
    <div>
      <header
        className={cx(styles.header)}
        style={{
          background: `rgba(255, 255, 255, ${headerAlpha})`,
        }}
      >
        <div className={styles.headerInner}>
          <div className={styles.internals}>
            <h1 title={siteTitle} className={styles.logo}>
              <a href="/">
                <img alt={siteTitle} src={Logo} height="40" width="77" loading="lazy" />
              </a>
            </h1>
            <nav className={cx(styles.mainNav, styles.merchant)}>
              <div className={styles.linkBox}></div>
              {merchantMenu.map(menuItem =>
                menuItem.link ? (
                  <div
                    className={cx(styles.linkBox, {
                      [styles.active]: menuItem.subMenu
                        ? pathname.startsWith(menuItem.link)
                        : pathname.endsWith(menuItem.link) ||
                          pathname.startsWith(menuItem.followLink),
                      [styles.withDropdown]: !!menuItem.subMenu,
                    })}
                    key={menuItem.link}
                  >
                    <a href={menuItem.link}>{menuItem.title}</a>
                    {menuItem.subMenu && (
                      <nav className={styles.subNav}>
                        {menuItem.subMenu.map(subMenuItem =>
                          subMenuItem.link ? (
                            <a
                              href={subMenuItem.link}
                              key={subMenuItem.link}
                              className={cx({
                                [styles.active]: pathname.endsWith(subMenuItem.link),
                              })}
                            >
                              {subMenuItem.title}
                            </a>
                          ) : (
                            <OutboundLink
                              key={subMenuItem.extLink}
                              href={subMenuItem.extLink}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {subMenuItem.title}
                            </OutboundLink>
                          )
                        )}
                      </nav>
                    )}
                  </div>
                ) : (
                  <div className={styles.linkBox} key={menuItem.extLink}>
                    <OutboundLink href={menuItem.extLink} rel="noopener noreferrer" target="_blank">
                      {menuItem.title}
                    </OutboundLink>
                  </div>
                )
              )}
            </nav>
          </div>
          <nav className={styles.externals}>
            <a
              className={cx(styles.toConsumerPage, {
                [styles.active]: pathname.endsWith('/merchant/contact_us/'),
              })}
              href="/merchant/contact_us/"
            >
              導入相談する
            </a>
            <OutboundLink
              className={styles.toMerchantDashboard}
              href="https://merchant.paidy.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ログイン
            </OutboundLink>
          </nav>
        </div>
      </header>
    </div>
  );
};

HeaderMerchant.defaultProps = {
  siteTitle: ``,
  pathname: '',
  showNav: true,
  showAllNavs: false,
};

export default HeaderMerchant;
